import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  byId: {},
  ratio: null,
  lastUpdated: null,
};

const pricesSlice = createSlice({
  name: 'prices',
  initialState,
  reducers: {
    pricesUpdated(state, action) {
      state.byId = action.payload;
      state.lastUpdated = Date.now();
    },
    ratioUpdate(state, action) {
      state.ratio = action.payload;
      state.lastUpdated = Date.now();
    },
  },
});

export const { pricesUpdated, ratioUpdate } = pricesSlice.actions;
export default pricesSlice.reducer;
